import { CommonRequestCertificateInterface } from 'front-office/view-models/common-certificate-form';
import { useCallback, useState, ReactElement } from 'react';
import AccountholderStorageContext from './context';

interface AccountholderStorageProviderProps {
  initialValues: CommonRequestCertificateInterface;
  children: ReactElement;
}

const AccountholderStorageProvider = ({
  initialValues,
  children,
}: AccountholderStorageProviderProps): ReactElement => {
  const [accountholderStorage, setAccountholderStorage] =
    useState<CommonRequestCertificateInterface>(initialValues);

  const setValues = useCallback(
    (values: CommonRequestCertificateInterface) => {
      setAccountholderStorage((oldValues) => ({ ...oldValues, ...(values || {}) }));
    },
    [setAccountholderStorage]
  );

  return (
    <AccountholderStorageContext.Provider
      value={{
        values: accountholderStorage,
        setValues,
      }}
    >
      {children}
    </AccountholderStorageContext.Provider>
  );
};

AccountholderStorageProvider.displayName = 'Filter Table Provider';

export default AccountholderStorageProvider;
